import $ from 'jquery';

class Accordion {
    constructor() {

        this.$accordionToggle = $('.js-accordion-button');

        this.$accordionToggle.on('click', $.proxy(this.toggleDescription, this));
    }

    toggleDescription(e) {
        const $elem = $(e.currentTarget);

        $elem.toggleClass('is-open');

        if ($elem.hasClass('is-open')) {
            $elem.attr('aria-expanded', 'true');
            $elem.next('.js-accordion-description').slideDown();
        } else {
            $elem.attr('aria-expanded', 'false');
            $elem.next('.js-accordion-description').slideUp();
        }
    }
}

export default Accordion;
